export const BOM_TYPES = {
  CHILD: 'CHILD',
  FLAT: 'FLAT',
} as const;
